import { render } from "./AppSelect.vue?vue&type=template&id=1d547602&scoped=true"
import script from "./AppSelect.vue?vue&type=script&lang=js"
export * from "./AppSelect.vue?vue&type=script&lang=js"

import "./AppSelect.vue?vue&type=style&index=0&id=1d547602&scoped=true&lang=css"

import exportComponent from "/Users/callum/Dev/saxton/saxton-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d547602"]])

export default __exports__